
const students = [
  {
    avatar:'https://avatars.githubusercontent.com/u/21546375?s=400&u=8837ab4e24638d6d6fa048d588957a9a0ba7b067&v=4',
    link: 'https://github.com/kilinich-v',
    name: 'Vladimir Kilinich',
    role: 'Team Lead',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/vladyslav-hapon.jpg',
    link: 'https://github.com/vladhpn',
    name: 'Vladyslav Hapon',
    role: 'Scrum Master',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/aleksandr-priadko.jpg',
    link: 'https://github.com/AleksandrPriadko',
    name: 'Aleksandr Priadko',
    role: 'Developer',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/alena-laptieva.jpg',
    link: 'https://github.com/olenaLa',
    name: 'Alena Laptieva',
    role: 'Developer',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/avatar-nogender.jpg',
    link: 'https://github.com/Bohdan-R',
    name: 'Bohdan Remeniuk',
    role: 'Developer',
  },
  {
    avatar: 'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/filip-koza.jpg',
    link: 'https://github.com/Fil1989',
    name: 'Filip Koza',
    role: 'Developer',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/luba.jpg',
    link: 'https://github.com/LiubovShpakova',
    name: 'Liubov Shpakova',
    role: 'Developer',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/marina-permiakova.jpg',
    link: 'https://github.com/Nickmarina',
    name: 'Marina Permiakova',
    role: 'Developer',
  },
  {
    avatar:'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/vladyslav-remeniuk.jpg',
    link: 'https://github.com/Dr-Frame',
    name: 'Vladyslav Remeniuk',
    role: 'Developer',
  },
  {
    avatar: 'https://raw.githubusercontent.com/kilinich-v/goit-Filmoteka-cp/dev/src/images/team-ava/volodymyr-kostetskyi.jpg',
    link: 'https://github.com/Nobergan',
    name: 'Volodymyr Kostetskyi',
    role: 'Developer',
  }
];
export default students;
